'use client';

import { useLayoutEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import type { AppMarketingAppLinks } from '@/features/app-marketing/logic/app-marketing-app-links';
import { isAllowedAppMarketingDownloadUrl } from '@/features/app-marketing/logic/is-safe-app-marketing-href';
import { detectClientPlatform } from '@/features/app-marketing/utils/detect-client-platform';

type AppMarketingAutoDownloadProps = {
    appLinks: AppMarketingAppLinks;
};

export const AppMarketingAutoDownload = ({ appLinks }: AppMarketingAutoDownloadProps) => {
    const searchParams = useSearchParams();
    const serializedAppLinks = useMemo(
        () => [appLinks.ios, appLinks.android, appLinks.mac, appLinks.windows].join('|'),
        [appLinks.android, appLinks.ios, appLinks.mac, appLinks.windows]
    );
    const shouldAutoDownload = searchParams.has('download');

    useLayoutEffect(() => {
        if (!shouldAutoDownload) {
            return;
        }

        const userAgent = navigator.userAgent || navigator.vendor || '';
        const { appLink } = detectClientPlatform(userAgent, appLinks);

        if (appLink && isAllowedAppMarketingDownloadUrl(appLink, appLinks)) {
            window.location.replace(appLink);
        }
    }, [appLinks, serializedAppLinks, shouldAutoDownload]);

    return null;
};
